"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WordTileGrid = void 0;
const material_1 = require("@mui/material");
const utils_1 = require("../../utils");
const WordTile_1 = require("./WordTile");
const react_1 = __importDefault(require("react"));
function WordTileGrid(props) {
    return (react_1.default.createElement(material_1.ThemeProvider, { theme: (0, utils_1.getTheme)(props.gameplayStyle) },
        react_1.default.createElement("div", { className: "gap-[8px] flex flex-wrap justify-center" }, props.texts.map((text, index) => {
            return (react_1.default.createElement(WordTile_1.WordTile, { key: index, id: text, onClick: e => {
                    const text = e.currentTarget.id;
                    if (props.onInteract) {
                        props.onInteract(text, index);
                    }
                }, text: text, gameplayStyle: props.gameplayStyle }));
        }))));
}
exports.WordTileGrid = WordTileGrid;
